import { render, staticRenderFns } from "./117.vue?vue&type=template&id=39aba409&scoped=true&"
var script = {}
import style0 from "./117.vue?vue&type=style&index=0&id=39aba409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aba409",
  null
  
)

export default component.exports